<!--
 * @Description: 申请开票-开票内容
 * @Date: 2025-05-20 15:57:04
-->
<template>
  <BaseForm
    ref="formRef"
    label-position="top"
    scrollToError
    :model="formData"
    :rules="formRules"
    :disabled="disabled"
  >
    <div class="form-dialog__title">
      <h1>开票信息</h1>
    </div>
    <div class="form-dialog__content">
      <BaseFormItem label="个体户名称" prop="theSellerId">
        <BaseSelect
          class="form-dialog__w280"
          placeholder="请选择"
          label-key="individualName"
          value-key="individualId"
          :init="true"
          :remoteMethod="gthRemote"
          v-model="formData.theSellerId"
          @change="onGthChange"
        ></BaseSelect>
      </BaseFormItem>
      <BaseFormItem label="发票类型" prop="invoiceType">
        <BaseSelect
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          v-model="formData.invoiceType"
          :options="INVOICE_TYPE"
          @change="onInvoiceTypeChange"
        ></BaseSelect>
      </BaseFormItem>
      <!-- 票税修改：支付通道 -->
      <BaseFormItem label="支付通道" prop="payPassagewayCode">
        <BaseSelect
          class="form-dialog__w280"
          type="text"
          placeholder="请选择"
          v-model="formData.payPassagewayCode"
          :options="PAY_CHANNEL_OPTIONS"
        ></BaseSelect>
      </BaseFormItem>
      <BaseFormItem label="选择日期" prop="receiveAt">
        <BaseDatePicker
          class="form-dialog__w280"
          style="width: 280px"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          type="daterange"
          v-model="formData.receiveAt"
        ></BaseDatePicker>
      </BaseFormItem>
      <!-- 票税修改：付款方式 -->
      <BaseFormItem label="付款方式" prop="payType">
        <BaseSelect
          class="form-dialog__w280"
          type="text"
          placeholder="请选择"
          v-model="formData.payType"
          :options="PAY_TYPE_OPTIONS"
        ></BaseSelect>
      </BaseFormItem>
    </div>
  </BaseForm>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseDatePicker,
  BaseSelect
} from 'xrk-components';
import {
  MakeOutAnInvoiceParams,
  NotInvoicedListParams
} from '@V/invoice/src/data-source/types';
import { selectParkList } from '@V/invoice/src/data-source/apis';
import { INVOICE_TYPE } from '@V/invoice/src/constants';
/** 支付通道（全局常量 @constants/bank） */
import { PAY_PASSAGEWAY_MAPPING } from '@constants/bank';
/** 付款方式（全局常量 @constants/order） */
import { PAY_TYPE } from '@constants/order';
import appStore from '@/store';
import { storeToRefs } from 'pinia';

type FormData = MakeOutAnInvoiceParams &
  NotInvoicedListParams & {
    individualId?: number | null;
    individualName?: string;
  };

withDefaults(
  defineProps<{
    disabled?: boolean;
  }>(),
  {}
);

const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

const formData = defineModel<FormData>();
const formRef = ref(null);

const formRules = {
  theSellerId: [{ required: true, message: '请选择', trigger: 'change' }],
  invoiceType: [{ required: true, message: '请选择', trigger: 'change' }],
  payPassagewayCode: [{ required: false, message: '请选择', trigger: 'change' }]
};

/** 支付通道选项（来源 @constants/bank PAY_PASSAGEWAY_MAPPING） */
const PAY_CHANNEL_OPTIONS = Object.values(PAY_PASSAGEWAY_MAPPING);

/** 付款方式选项（来源 @constants/order PAY_TYPE） */
const PAY_TYPE_OPTIONS = Object.values(PAY_TYPE);

const gthRemote = (keyWord: string) => {
  return selectParkList({
    keyWord,
    pageNum: 1,
    pageSize: 200,
    loginUserId: userInfo.value.loginUserId,
    functionCode: userInfo.value.functionCode
  });
};

const onGthChange = (val, [option]) => {
  formData.value.itemId = null;
  formData.value.entpCertNo = option.entpCertNo;
  formData.value.individualId = option.individualId;
  formData.value.individualName = option.individualName;
};
const onInvoiceTypeChange = () => {
  formData.value.itemId = null;
};
defineExpose({
  validate: (...args: any) => formRef.value?.validate(...args)
});
</script>
